export const yesNo = [
    {
        id: 0,
        title: 'Yes',
        group: "yesNo",
    },
    {
        id: 1,
        title: 'No',
        group: 'yesNo',
    },
]

export const fileCads = [
    {
        id: 0,
        title: 'Yes',
        group: "fileCad",
    },
    {
        id: 1,
        title: 'No',
        group: 'fileCad',
    },
];

export const cadSoftware = [
    {
        "id": 'I would like to use your CAD software to design what I need', "title": "I would like to use your CAD software to design what I need", "group": "cadSoftware"
    }, {
        "id": 'I would like help designing what I need', "title": "I would like help designing what I need", "group": "cadSoftware"
    },
];

export const partComponent = [
    {
        "id": 0, "title": "Yes", "group": "partComponent"
    }, {
        "id": 1, "title": "No", "group": "partComponent"
    },
];

export const designServices = [
    {
        "id": 0, "title": "Yes", "group": "partComponent"
    }, {
        "id": 1, "title": "No", "group": "partComponent"
    },
];

export const leadTime = [
    {
        title: "Priority 2-3 Days*", "value": "Priority 2-3 Days*"
    },
    {
        title: "Economy Extended 3-Week Service", "value": "Economy Extended 3-Week Service"
    },
    {
        title: "Please quote both options", "value": "Please quote both options"
    },
];
export const compliantPrograms = [
    {
        title: "ITAR", "value": "ITAR"
    },
    {
        title: "Canadian Controlled Goods Program", "value": "Canadian Controlled Goods Program"
    },{
        title: "N/A", "value": "N/A"
    },
];

export const documentation = [
    {
        title: "REACH", "value": "REACH"
    },
    {
        title: "RoHS", "value": "RoHS"
    },
    {
        title: "Traceability", "value": "Traceability"
    },
];

export const typeofInspection = [
    {
        title: "First-Article Inspection", "value": "First-Article Inspection"
    },
    {
        title: "AS9102", "value": "AS9102"
    },
    {
        title: "Custom", "value": "Custom"
    },
];

export const certificateOfConformance = [
    { title: "Standard - Certificate of Conformance(C of C)" },
    { title: "Custom - Certificate of Conformance(C of C)" },
    { title: "Standard - Certificate of Conformance(C of C) with a combined First Article Inspection(FAI)" },
    { title: "Basic Station" },
    { title: "Basic Station Custom" },
    { title: "Premium AS9102" },
    { title: "Premium AS9102 Custom" },
];


export const frequencyOfInspection = [

    {
        "id": "100%", "title": "100%", "group": "inspectionPerLot",
    },
    {
        "id": "1st Part", "title": "1st Part", "group": "inspectionPerLot",
    },
    {
        "id": "1st Part/Lot", "title": "1st Part/Lot", "group": "inspectionPerLot",
    },

];

export const inspectionPerLot = [
    {
        "id": 0, "title": "Per Lot", "group": "inspectionPerLot",
    },
    {
        "id": 1, "title": "100%", "group": "inspectionPerLot",
    },

];
export const templateGeneratorCadFile = [
    {
        "id": 0, "title": "Yes", "group": "templateGeneratorCadFile",
    },
    {
        "id": 1, "title": "No", "group": "templateGeneratorCadFile",
    },
];

export const mutiplePartsAssembly = [
    {
        id: 'True', "title": "Yes",
    },
    {
        id: 'False', "title": "No",
    },
];

export const similarPartOrder = [
    {
        "id": 'True', "title": "Yes", "group": "similarPartOrder",
    },
    {
        "id": 'False', "title": "No", "group": "similarPartOrder",
    },
];

export const quoteSubstitutions = [
    {
        "id": 'True', "title": "Yes", "group": "quoteSubstitutions",
    },
    {
        "id": 'False', "title": "No", "group": "quoteSubstitutions",
    },
];

export const minorDesignModifications = [
    {
        "id": 0, "title": "Yes", "group": "minorDesignModifications",
    },
    {
        "id": 1, "title": "No", "group": "minorDesignModifications",
    },
];

export const criticalAspects = [
    {
        "id": 0, "title": "Yes", "group": "criticalAspects",
    },
    {
        "id": 1, "title": "No", "group": "criticalAspects",
    },
];




